<template>
  <div>
    <Header ref="header"></Header>
    <router-view></router-view>
    <Footer ref="footer"></Footer>
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
      <span>是否退出登录</span>
      <span slot="footer" class="dialog-footer">
        <div class="dialog-footer-btn flex_center" @click="centerDialogVisible = false">
          再看看
        </div>
        <div class="dialog-footer-btn flex_center dialog-footer-btn2" @click="handleLogout">
          退出登录
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      centerDialogVisible: false,
    };
  },
  mounted() {
    // this.isIe = this.getBrowser();
  },
  methods: {
    handleLogout() {
      this.$api.userLogout().then((res) => {
        if (res.code == 1) {
          this.centerDialogVisible = false;
          window.localStorage.clear();
          this.$router.push("/login");
        }
      });
    },
  },
};
</script>
<style lang="less">
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: center;

  .dialog-footer-btn {
    width: 88px;
    height: 33px;
    background-color: #f2f3f5;
    border-radius: 4px;
    color: #999999;
    font-size: 14px;
    cursor: pointer;
  }

  .dialog-footer-btn2 {
    background-color: #0d4987;
    color: #fff;
    margin-left: 12px;
  }
}

.ie_main {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding-top: 80px;
  height: 100vh;
  font-size: 40px;
  line-height: 1.5;
}

@media (max-width: 680px) {
  .el-dialog {
    min-width: 280px;
  }
}
</style>